import pick from 'lodash/pick';
import values from 'lodash/values';

export default {
  FILTERFIELD: 'filter',
  EDITFIELD: 'editField',
  MAIN_RESULTS_CANCEL_ID: 'main_results_cancel_id',
  FIELD_TYPE_BELONGS_TO_MANY: 'belongs_to_many',
  FIELD_TYPE_BELONGS_TO: 'belongs_to',
  VALUE_ADAPT_SUBSTITUTE: 'substitute',
  VALUE_ADAPT_OVERWRITE: 'overwrite',
  NEW_ITEM: 'new',
  VIEW_EDIT: 'edit',
  VIEW_VIEW: 'view',
  VIEW_TABULAR: 'tabular',
  VIEW_AUTH: 'auth',
  VIEW_SUBVIEW: 'subview',
  DEFAULT_SUBVIEW_GROUP: 'subviews',
  APP_PAGE: 'app',
  APP_PAGE_MODEL: 'model',
  APP_PAGE_NOTFOUND: 'notFound',
  APP_PAGE_NOT_AUTHORIZED: 'notAuthorized',
  APP_PAGE_ERROR: 'error',
  MENU_MAJOR: 'major',
  MENU_MINOR: 'minor',
  MENU_ICON: 'icon',
  STATUS_STARTED: 'started_at',
  STATUS_SUCCESS: 'successfull',
  STATUS_ERRORED: 'errored',
  STATUS_CANCELED: 'canceled',
  STATUS_INVALIDATED: 'invalidated',
  SEARCH_FILTER_NAME: 'search',

  subview: (subview) => {
    return values(pick(subview, ['model', 'filterValue', 'filterName'])).join('$');
  },
  modelResultsRequestGroup(modelId) {
    return `${modelId}_results`;
  },

  modelItemRequestGroup(modelId, itemId) {
      return `${modelId}_item_${itemId}`;
  },

  modelFieldRequestGroup(modelId, inputType, name) {
    return `${modelId}_${inputType}_${name}`;
  },

  titleRowIdentifier(baseName) {
    return `${baseName}_title_row`;
  },
    
  searchRequestGroup(modelName) {
    return `${modelName}_search`;
  },
  
  modelSettingsIdentifier(modelName) {
    return `${modelName}_model`;
  }
};